import { Apple, Play } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/motogo-rider/id6761649259";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=app.emergent.searchsuggestions06dc5e67";
export const INSTAGRAM_URL = "https://www.instagram.com/motogo.global/";

const baseClasses =
  "group inline-flex items-center gap-3 rounded-xl px-5 py-3 font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#39FF14]/70 active:translate-y-[1px]";
const primary =
  "bg-[#39FF14] text-black hover:bg-[#6BFF55] shadow-[0_0_0_1px_rgba(57,255,20,0.35),0_18px_60px_rgba(0,0,0,0.35)]";
const glass =
  "bg-white/6 text-white border border-white/12 hover:bg-white/10 hover:border-white/16 hover:shadow-[0_0_0_1px_rgba(57,255,20,0.25),0_0_28px_rgba(57,255,20,0.14)]";

export const AppStoreButton = ({ testId = "hero-app-store-button", variant = "primary" }) => {
  const { t } = useLanguage();
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${baseClasses} ${variant === "primary" ? primary : glass}`}
    >
      <Apple className="w-5 h-5" />
      <span className="flex flex-col items-start leading-tight">
        <span className="text-[10px] font-medium uppercase tracking-wider opacity-80">{t.hero.appStoreSub}</span>
        <span className="text-sm font-semibold">{t.hero.appStoreMain}</span>
      </span>
    </a>
  );
};

export const GooglePlayButton = ({ testId = "hero-google-play-button", variant = "glass" }) => {
  const { t } = useLanguage();
  return (
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${baseClasses} ${variant === "primary" ? primary : glass}`}
    >
      <Play className="w-5 h-5" />
      <span className="flex flex-col items-start leading-tight">
        <span className="text-[10px] font-medium uppercase tracking-wider opacity-80">{t.hero.playSub}</span>
        <span className="text-sm font-semibold">{t.hero.playMain}</span>
      </span>
    </a>
  );
};
